var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-home-component home-page"},[_c('header_section'),_vm._v(" "),_c('div',{staticClass:"home-vue-content"},[_c('home_slider'),_vm._v(" "),_c('home_content'),_vm._v(" "),_c('footer_section')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }